module.exports = __webpack_public_path__ + "FuturaStd-Bold.otf?fdc3307ae96cca471174fe427ad16639";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/FuturaStd-Bold.otf
// module id = 92
// module chunks = 0